import React from 'react';
import YeastSimulation from './YeastSimulation';
import './App.css';

function App() {
  return (
    <div className="App">
      <YeastSimulation />
    </div>
  );
}

export default App;